import { render, staticRenderFns } from "./StandaloneForgeViewer.vue?vue&type=template&id=d03a83cc&scoped=true"
import script from "./StandaloneForgeViewer.vue?vue&type=script&lang=js"
export * from "./StandaloneForgeViewer.vue?vue&type=script&lang=js"
import style0 from "./StandaloneForgeViewer.vue?vue&type=style&index=0&id=d03a83cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d03a83cc",
  null
  
)

export default component.exports